import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "edit-form" }
const _hoisted_4 = { class: "password-form" }
const _hoisted_5 = { class: "danger" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.CLIENT,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['CLNT_UPDATE'] && !_ctx.loading]
        ]),
        (_ctx.clientModel && _ctx.hasPermission['CLNT_UPDATE'])
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Ämter', '/client'], [_ctx.clientModel.name]]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['CLNT_UPDATE'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 10 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_el_form, {
                                ref: "editClientForm",
                                rules: _ctx.rulesClient,
                                "label-position": "top",
                                model: _ctx.clientModel,
                                labelWidth: "120px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "Bezeichnung",
                                    prop: "name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.clientModel.name,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.clientModel.name) = $event)),
                                        onInput: _ctx.onClientInput
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "Präfix",
                                    prop: "tokenprefix"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.clientModel.tokenprefix,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.clientModel.tokenprefix) = $event)),
                                        onInput: _ctx.onClientInput,
                                        maxlength: 2
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "E-Mail",
                                    prop: "email"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.clientModel.email,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.clientModel.email) = $event)),
                                        onInput: _ctx.onClientInput
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "Strasse",
                                    prop: "street"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.clientModel.street,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.clientModel.street) = $event)),
                                        onInput: _ctx.onClientInput
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "Postleitzahl",
                                    prop: "zipcode"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.clientModel.zipcode,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.clientModel.zipcode) = $event)),
                                        onInput: _ctx.onClientInput
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "Ort",
                                    prop: "city"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.clientModel.city,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.clientModel.city) = $event)),
                                        onInput: _ctx.onClientInput
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        disabled: !_ctx.formClientValid,
                                        onClick: _ctx.onClientSaveClick
                                      }, {
                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                          _createTextVNode(" Speichern ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["rules", "model"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 13 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _withDirectives(_createElementVNode("div", _hoisted_5, _cache[10] || (_cache[10] = [
                                _createElementVNode("h4", null, "Achtung:", -1),
                                _createElementVNode("p", null, "Es wurde noch kein Passwort vergeben. Ohne ein Passwort ist die Anmeldung für dieses Amt unmöglich.", -1)
                              ]), 512), [
                                [_vShow, !_ctx.oldPassword && !_ctx.loadingPassword]
                              ]),
                              _createVNode(_component_el_form, {
                                ref: "editPasswordForm",
                                rules: _ctx.rulesPassword,
                                "status-icon": "",
                                "label-position": "top",
                                model: _ctx.passwordForm,
                                "label-width": "120px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "Passwort",
                                    prop: "newPassword"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.passwordForm.newPassword,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.passwordForm.newPassword) = $event)),
                                        type: "password",
                                        autocomplete: "off",
                                        onInput: _ctx.onPasswordInput
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "Passwort wiederholen",
                                    prop: "repeatPassword"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.passwordForm.repeatPassword,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.passwordForm.repeatPassword) = $event)),
                                        type: "password",
                                        autocomplete: "off",
                                        onInput: _ctx.onPasswordInput
                                      }, null, 8, ["modelValue", "onInput"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        disabled: !_ctx.formPasswordValid,
                                        onClick: _ctx.onPasswordSaveClick,
                                        loading: _ctx.loadingPassword
                                      }, {
                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                          _createTextVNode(" Passwort speichern ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled", "onClick", "loading"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["rules", "model"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}